import { render } from "./MultipdrsFile.vue?vue&type=template&id=00636d5a&scoped=true"
import script from "./MultipdrsFile.vue?vue&type=script&lang=js"
export * from "./MultipdrsFile.vue?vue&type=script&lang=js"

import "./MultipdrsFile.vue?vue&type=style&index=0&id=00636d5a&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00636d5a"]])

export default __exports__